import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ObjectActions from './bulk-move-mobile-logbooks.actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as LogbookAppReducer from '../logbook.reducer';
import * as AppActions from '../app/actions';
import {
  IBulkResponseRecord,
  IGetManyResponse,
  IGetOneResponse,
} from '../../shared/model/interface/crud-response-interface.model';
import { BulkMoveMobileLogbooksService } from './bulk-move-mobile-logbooks.service';
import {
  IBulkMoveMobileLogbooksModalDataResponse,
  IBulkMoveMobileLogbooksResponse,
} from './bulk-move-mobile-logbooks.model';

@Injectable()
export class BulkMoveMobileLogbooksEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<LogbookAppReducer.LogbookAppState>,
    private readonly bulkMoveMobileLogbooksService: BulkMoveMobileLogbooksService,
  ) {}

  getBulkMoveLogbookModalDataEffect = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.GET_BULK_MOVE_LOGBOOK_MODAL_DATA),
      switchMap((payload: ObjectActions.GetBulkMoveLogbookModalData) => {
        this.store.dispatch(new AppActions.ShowLoader());

        return this.bulkMoveMobileLogbooksService.getBulkMoveLogbookModalData().pipe(
          switchMap((response: IGetManyResponse<IBulkMoveMobileLogbooksModalDataResponse>) => {
            return of(new ObjectActions.GetBulkMoveLogbookModalDataCompleted(response), new AppActions.HideLoader());
          }),
          catchError((errorRes) => {
            return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
          }),
        );
      }),
      catchError((errorRes) => {
        return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
      }),
    ),
  );

  bulkMoveMobileLogbooksEffect = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.BULK_MOVE_MOBILE_LOGBOOKS),
      switchMap((payload: ObjectActions.BulkMoveMobileLogbooks) => {
        this.store.dispatch(new AppActions.ShowLoader());

        return this.bulkMoveMobileLogbooksService.bulkMoveMobileLogbooks(payload.params, payload.issuerAndReason).pipe(
          switchMap((response: IBulkResponseRecord<IGetOneResponse<IBulkMoveMobileLogbooksResponse>>) => {
            return of(new ObjectActions.BulkMoveMobileLogbooksCompleted(response), new AppActions.HideLoader());
          }),
          catchError((errorRes) => {
            return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
          }),
        );
      }),
      catchError((errorRes) => {
        return of(new ObjectActions.FetchError(errorRes), new AppActions.HideLoader());
      }),
    ),
  );
}
